import { render, staticRenderFns } from "./OrderGoodsModal.vue?vue&type=template&id=2e4e63f8&scoped=true"
import script from "./OrderGoodsModal.vue?vue&type=script&lang=js"
export * from "./OrderGoodsModal.vue?vue&type=script&lang=js"
import style0 from "./OrderGoodsModal.vue?vue&type=style&index=0&id=2e4e63f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4e63f8",
  null
  
)

export default component.exports